// DbOrderBar/DbOrderBar.styles.ts
import { StyleSheet } from 'react-native';

const colors = {
  light: {
    background: '#FFFFFF',
    text: '#333333',
    subText: '#999999',
    border: '#E8E8E8',
    divider: '#F0F0F0',
    primary: '#007AFF',
    badge: '#FF3B30',
    badgeText: '#FFFFFF',
    disabled: '#CCCCCC',
    iconBackground: '#F7F8FA',
  },
  dark: {
    background: '#1A1A1A',
    text: '#FFFFFF',
    subText: '#999999',
    border: '#3A3A3A',
    divider: '#333333',
    primary: '#0A84FF',
    badge: '#FF453A',
    badgeText: '#FFFFFF',
    disabled: '#666666',
    iconBackground: '#2A2A2A',
  },
};

export const createStyles = (theme: 'light' | 'dark' = 'light') => {
  const c = colors[theme];

  return StyleSheet.create({
    // 容器
    container: {
      backgroundColor: c.background,
    },
    
    // 标题区域
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 16,
      paddingTop: 12,
      // 
    },
    headerLeft: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
    },
    title: {
      fontSize: 17,
      fontWeight: '600',
      color: c.text,
    },
    headerRight: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingLeft: 12,
    },
    rightText: {
      fontSize: 14,
      color: c.subText,
      marginRight: 0,
    },
    
    // 分割线
    divider: {
      height: StyleSheet.hairlineWidth,
      backgroundColor: c.divider,
      marginTop: 8,
    },
    
    // Fixed 布局容器
    fixedContainer: {
      flexDirection: 'row',
      paddingVertical: 16, // 
      paddingHorizontal: 8,
      justifyContent: 'space-around',
    },
    
    // Scroll 布局容器
    scrollContainer: {
      paddingHorizontal: 16,
      paddingVertical: 16,
    },
    scrollContent: {
      flexDirection: 'row',
      gap: 24,
    },
    
    // 订单项
    orderItem: {
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 60,
    },
    orderItemFixed: {
      flex: 1,
    },
    orderItemDisabled: {
      opacity: 0.5,
    },
    
    // 图标容器
    iconContainer: {
      width: 40,
      height: 40,
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 0,
      position: 'relative',
    },
    
    // 徽标
    badge: {
      position: 'absolute',
      top: -4,
      right: -4,
      minWidth: 18,
      height: 18,
      borderRadius: 9,
      backgroundColor: c.badge,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 5,
      borderWidth: 2,
      borderColor: c.background,
    },
    badgeText: {
      fontSize: 10,
      fontWeight: '600',
      color: c.badgeText,
    },
    
    // 文字
    itemText: {
      fontSize: 12,
      color: c.text,
      textAlign: 'center',
      lineHeight: 16,
    },
    itemTextDisabled: {
      color: c.disabled,
    },
  });
};

export const ORDER_BAR_DEFAULTS = {
  gap: 0,
  padding: 16,
  horizontalPadding: 0,
  iconSize: 28,
};
